module.exports = __webpack_public_path__ + "static/forms-recipients-dont-f7663e4e62803d0bbb10a90305b4a994.png";